module.exports = __webpack_public_path__ + "img/cocobank-logo.32f41d22.png";